const getPriceString = ({ amount, currency }) =>
  // eslint-disable-next-line no-irregular-whitespace
  currency && amount && `${currency.toLowerCase() === 'eur' ? `€${amount}` : `${amount} ₽`}`;

export { getPriceString };
